export const HOME_BASE_URL = '/';